<template>
  <b-form-group :label="label">
    <b-form-input v-model.trim="inputValue" :type="type" :placeholder="placeholder" required></b-form-input>
  </b-form-group>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
    type: {
      type: String,
      default: "text",
    },
    placeholder: String,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
